<!-- Profile -->
<div class="page-header">
  <div class="header-content">
    <div class="header-main">
      <div class="header-icon">
        <i class="fas fa-user-circle"></i>
      </div>
      <div class="header-text">
        <h1 class="page-title">My Profile</h1>
        <p class="page-description">View your account information</p>
      </div>
    </div>
  </div>
</div>

<!-- Profile Card -->
<div class="row g-4">
  <!-- Avatar & Name Section -->
  <div class="col-lg-4">
    <div class="data-panel">
      <div class="panel-body" style="padding: 32px 24px; text-align: center;">
        <div style="width: 100px; height: 100px; border-radius: 50%; background: var(--accent-subtle); color: var(--accent); display: flex; align-items: center; justify-content: center; font-size: 36px; margin: 0 auto 16px; border: 3px solid var(--accent-border);">
          <i class="fas fa-user"></i>
        </div>
        <h4 style="font-size: 18px; font-weight: 700; color: var(--text-primary); margin-bottom: 4px;">Jared Jared</h4>
        <span class="badge badge-soft-primary badge-lg" style="margin-top: 8px;">
          <i class="fas fa-shield-alt me-1"></i>Moderator
        </span>
      </div>
    </div>
  </div>

  <!-- Details Section -->
  <div class="col-lg-8">
    <!-- Personal Information -->
    <div class="data-panel" style="margin-bottom: 20px;">
      <div class="panel-header">
        <div class="panel-title">
          <div class="title-icon">
            <i class="fas fa-id-card"></i>
          </div>
          <div class="title-content">
            <div class="title-text">Personal Information</div>
            <div class="title-subtitle">Your personal details</div>
          </div>
        </div>
      </div>
      <div class="panel-body" style="padding: 20px;">
        <div class="row g-4">
          <div class="col-sm-6">
            <div style="margin-bottom: 4px;">
              <span style="font-size: 12px; font-weight: 600; color: var(--text-tertiary); text-transform: uppercase; letter-spacing: 0.05em;">First Name</span>
            </div>
            <div style="font-size: 14px; font-weight: 500; color: var(--text-primary);">Jared</div>
          </div>
          <div class="col-sm-6">
            <div style="margin-bottom: 4px;">
              <span style="font-size: 12px; font-weight: 600; color: var(--text-tertiary); text-transform: uppercase; letter-spacing: 0.05em;">Last Name</span>
            </div>
            <div style="font-size: 14px; font-weight: 500; color: var(--text-primary);">Jared</div>
          </div>
          <div class="col-sm-6">
            <div style="margin-bottom: 4px;">
              <span style="font-size: 12px; font-weight: 600; color: var(--text-tertiary); text-transform: uppercase; letter-spacing: 0.05em;">Email Address</span>
            </div>
            <div style="font-size: 14px; font-weight: 500; color: var(--text-primary);">{{'j.evans@email.com'}}</div>
          </div>
          <div class="col-sm-6">
            <div style="margin-bottom: 4px;">
              <span style="font-size: 12px; font-weight: 600; color: var(--text-tertiary); text-transform: uppercase; letter-spacing: 0.05em;">Phone Number</span>
            </div>
            <div style="font-size: 14px; font-weight: 500; color: var(--text-primary);">{{'+234805365147'}}</div>
          </div>
        </div>
      </div>
    </div>

    <!-- Account Information -->
    <div class="data-panel">
      <div class="panel-header">
        <div class="panel-title">
          <div class="title-icon">
            <i class="fas fa-cog"></i>
          </div>
          <div class="title-content">
            <div class="title-text">Account Information</div>
            <div class="title-subtitle">Your account role and status</div>
          </div>
        </div>
      </div>
      <div class="panel-body" style="padding: 20px;">
        <div class="row g-4">
          <div class="col-sm-6">
            <div style="margin-bottom: 4px;">
              <span style="font-size: 12px; font-weight: 600; color: var(--text-tertiary); text-transform: uppercase; letter-spacing: 0.05em;">Role</span>
            </div>
            <div>
              <span class="badge badge-soft-primary">{{'Moderator'}}</span>
            </div>
          </div>
          <div class="col-sm-6">
            <div style="margin-bottom: 4px;">
              <span style="font-size: 12px; font-weight: 600; color: var(--text-tertiary); text-transform: uppercase; letter-spacing: 0.05em;">Status</span>
            </div>
            <div>
              <span class="badge badge-dot badge-soft-success">Active</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
